import queens from './queens'

export default function (axios, config) {
  return {
    invalidate () {
      this.getAll.invalidate()
      this.getOne.invalidate()
    },
    getAll: config.cachedFunction(async function () {
      const listResponse = await axios({
        url: config.serverUrl + '/api/nodes/colony?_format=json',
        method: 'get',
        withCredentials: true
      })
      return (await Promise.all(Object.values(listResponse.data.result).map(async function (row) {
        if (!(1 * row.id)) {
          return null
        }

        const completeRow = {
          id: row.id,
          title: row.title
        }

        const detailsResponse = await axios({
          url: config.serverUrl + '/api/node/' + completeRow.id + '?_format=json',
          method: 'get',
          withCredentials: true
        })

        const result = Object.values(detailsResponse.data.result)[0]

        completeRow.apiary = result.currentApiary
        completeRow.field_massnahmen_und_aktionen = result.field_massnahmen_und_aktionen

        if (1 * result.currentQueen) {
          const queen = await queens(axios, config).getOne(result.currentQueen)
          // console.log(queen)
          if (queen) {
            completeRow.crownColor = queen.crownColor
            completeRow.queen = queen.id
          }
        }

        return completeRow
      }))).filter(function (row) { return row })
    }),
    getOne: config.cachedFunction(async function (id) {
      const detailsResponse = await axios({
        url: config.serverUrl + '/api/node/' + id + '?_format=json',
        method: 'get',
        withCredentials: true
      })
      const row = Object.values(detailsResponse.data.result)[0]

      return {
        id: row.id,
        title: row.title,
        apiary: row.currentApiary,
        queen: row.currentQueen
      }
    }),
    save ({ id, title, apiary, token }) {
      this.invalidate()
      const data = {
        title,
        field_massnahmen_und_aktionen: [
          {
            type: 'aktion_neuer_bienenstand',
            field_bienenstand: apiary
          }
        ]
      }

      const url = (id ? config.serverUrl + '/api/node/' + id + '?_format=json' : config.serverUrl + '/api/node/colony?_format=json')

      return axios({
        url,
        method: (id ? 'patch' : 'post'),
        data: data,
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
    },
    async unite ({ from, to, useQueen, token }) {
      this.invalidate()
      let result
      const fromData = {
        field_massnahmen_und_aktionen: [
          {
            type: 'aktion_vereinigung',
            field_volk: to
          }
        ]
      }

      const fromResult = await axios({
        url: config.serverUrl + '/api/node/' + from + '?_format=json',
        method: 'patch',
        data: fromData,
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
      result = fromResult
      if (useQueen) {
        const queen = (await this.getOne(from)).queen
        const toData = {
          field_massnahmen_und_aktionen: [
            {
              type: 'aktion_neue_koenigin',
              field_koenigin: queen
            }
          ]
        }
        const toResult = await axios({
          url: config.serverUrl + '/api/node/' + to + '?_format=json',
          method: 'patch',
          data: toData,
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
        result = fromResult && toResult
      }

      return result
    },
    deleteItem ({ id, token }) {
      this.invalidate()
      const url = config.serverUrl + '/api/node/' + id + '?_format=json'

      return axios({
        url,
        method: 'delete',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
    }
  }
}
